import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { take } from 'rxjs/operators';
import { DefinitionService } from '../../../../../../../core/definition/definition.service';
import { Definition } from '../../../../../../../core/definition/definition';
import { FitType } from '../../../../../../../core/store/fit/fit-type.enum';

interface CompanyItem {
  id: string;
  name: string;
  systemName: string;
  selected: boolean;
}

@Component({
  standalone: false,
  selector: 'app-company-filters',
  templateUrl: './company-filters.component.html',
  styleUrls: ['./company-filters.component.scss']
})
export class CompanyFiltersComponent implements OnInit, OnChanges {
  @Input() selectedCompanies: string[] = [];
  @Output() selectionChange = new EventEmitter<{ banners: string[], bannerLabels: string[] }>();

  searchTerm: string = '';
  isLoading: boolean = true;
  companies: CompanyItem[] = [];

  constructor(private definitionService: DefinitionService) { }

  ngOnInit(): void {
    this.definitionService.findAllFits()
      .pipe(take(1))
      .subscribe((definitions: Definition<FitType>[]) => {
        this.companies = definitions.map((def, index) => ({
          id: String(index + 1),
          name: def.displayName,
          systemName: String(def.systemName),
          selected: false
        }));
        this.companies.sort((a, b) => a.name.localeCompare(b.name));
        this.updateSelections();
        this.isLoading = false;
      });
  }

  ngOnChanges(): void {
    this.updateSelections();
  }

  private updateSelections(): void {
    if (!this.companies.length) return;
    this.companies.forEach(company => {
      company.selected = this.selectedCompanies.includes(company.systemName);
    });
  }

  onSearchChange(event: any): void {
    this.searchTerm = event.target.value;
  }

  clearSearch(): void {
    this.searchTerm = '';
  }

  toggleSelection(item: CompanyItem): void {
    item.selected = !item.selected;
    this.emitSelectionChange();
  }

  private emitSelectionChange(): void {
    const selected = this.companies.filter(c => c.selected);
    this.selectionChange.emit({
      banners: selected.map(c => c.systemName),
      bannerLabels: selected.map(c => c.name)
    });
  }

  resetSelections(): void {
    this.companies.forEach(company => company.selected = false);
    this.emitSelectionChange();
  }

  getFilteredItems(): CompanyItem[] {
    if (!this.searchTerm) return this.companies;
    return this.companies.filter(item => 
      item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
}